<template>
  <div class="inputs" ref="inputs">
    <eco-input
      size="small"
      v-if="isShowInput"
      autocomplete="off"
      placeholder="请输入内容"
      :disabled="!isEdit && isShowInput"
      type="text"
      v-model="inputValue"
      :permission="'w'"
    >
      <template slot="append">
        <el-button
          btn="btn"
          size="small"
          type="primary"
          :icon="this.icon"
          @click="customEvilJS()"
          >{{ this.btnName }}</el-button
        >
      </template>
    </eco-input>
    <el-button
      v-if="!isShowInput"
      btn="btn"
      style="
        height: 32px;
        border: 1px solid #dcdfe6;
        background: #f5f7fa;
        color: #909399;
        margin-bottom: 15px;
      "
      size="small"
      type="primary"
      :icon="this.icon"
      @click="customEvilJS()"
      >{{ this.btnName }}</el-button
    >
  </div>
</template>
<script>
import utils from "@/utils.js";
import { Message, Loading } from "element-ui";
import { Base64 } from "js-base64";
import i18n from "@/locale/index.js";
import req from "@/request.js";
export default {
  name: "eip-button",
  props: [
    "value",
    "name",
    "permission",
    "icon",
    "btnName",
    "attr",
    "configAttributes",
    "htCustomScript",
    "isShowInput"
  ],
  data() {
    return {
      isEdit: true,
      unwatchAry: [],
      inputValue: "",
      content: ""
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    value: {
      handler(newval, oldval) {
        if (
          (newval || newval == undefined || newval == 0) &&
          newval !== oldval
        ) {
          this.inputValue = newval;
        }
      }
    }
  },
  mounted() {
    if (this.value) {
      this.inputValue = this.value;
    }
    if (this.configAttributes) {
      if (this.configAttributes.isInputEdit) {
        this.isEdit = !this.configAttributes.isInputEdit;
      } else {
        this.isEdit = true;
      }
    } else {
      this.isEdit = true;
    }
  },
  methods: {
    customEvilJS() {
      let _me = this;
      let htCustomScript = Base64.decode(this.htCustomScript);
      const formVm = utils.getOnlineFormInstance(_me);

      function evil() {
        let Fn = Function(
          "req",
          "data",
          "i18n",
          "Message",
          "Loading",
          "formVm",
          htCustomScript
        ); //一个变量指向Function，防止有些前端编译工具报错
        let result = Fn(req, formVm.data, i18n, Message, Loading, formVm);
        return result;
      }
      let resultValue = evil();
      if (formVm && formVm.data && formVm.data.bid_bond) {
        formVm.data.bid_bond.showDetail = true;
        formVm.data.bid_bond = Object.assign({}, formVm.data.bid_bond, {
          showDetail: true
        });
      }
      if (formVm && formVm.data && formVm.data.pro_submit) {
        if (formVm.data.pro_submit.showRecord == true) {
          formVm.data.pro_submit.showRecord = true;
          formVm.data.pro_submit = Object.assign({}, formVm.data.pro_submit, {
            showRecord: true
          });
        } else if (formVm.data.pro_submit.showNumRecord == true) {
          formVm.data.pro_submit.showNumRecord = true;
          formVm.data.pro_submit = Object.assign({}, formVm.data.pro_submit, {
            showNumRecord: true
          });
        }
      }
      if (formVm && formVm.data && formVm.data.pro_data_archive) {
        if (formVm.data.pro_data_archive.showRecord == true) {
          formVm.data.pro_data_archive.showRecord = true;
          formVm.data.pro_data_archive = Object.assign(
            {},
            formVm.data.pro_data_archive,
            {
              showRecord: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.concentrate_purchase_apply) {
        if (formVm.data.concentrate_purchase_apply.insert == true) {
          formVm.data.concentrate_purchase_apply.insert = true;
          formVm.data.concentrate_purchase_apply = Object.assign(
            {},
            formVm.data.concentrate_purchase_apply,
            {
              insert: true
            }
          );
        }
        if (formVm.data.concentrate_purchase_apply.export == true) {
          formVm.data.concentrate_purchase_apply.export = true;
          formVm.data.concentrate_purchase_apply = Object.assign(
            {},
            formVm.data.concentrate_purchase_apply,
            {
              export: true
            }
          );
        }
        if (formVm.data.concentrate_purchase_apply.import == true) {
          formVm.data.concentrate_purchase_apply.import = true;
          formVm.data.concentrate_purchase_apply = Object.assign(
            {},
            formVm.data.concentrate_purchase_apply,
            {
              import: true
            }
          );
        }
        if (formVm.data.concentrate_purchase_apply.showPlan == true) {
          formVm.data.concentrate_purchase_apply.showPlan = true;
          formVm.data.concentrate_purchase_apply = Object.assign(
            {},
            formVm.data.concentrate_purchase_apply,
            {
              showPlan: true
            }
          );
        }
        if (formVm.data.concentrate_purchase_apply.showDetail == true) {
          formVm.data.concentrate_purchase_apply.showDetail = true;
          formVm.data.concentrate_purchase_apply = Object.assign(
            {},
            formVm.data.concentrate_purchase_apply,
            {
              showDetail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.pro_delivery) {
        formVm.data.pro_delivery.complete_detail_show = true;
        formVm.data.pro_delivery = Object.assign({}, formVm.data.pro_delivery, {
          complete_detail_show: true
        });
      }
      if (formVm && formVm.data && formVm.data.purchase_payment_apply) {
        formVm.data.purchase_payment_apply.showSelect = true;
        formVm.data.purchase_payment_apply = Object.assign(
          {},
          formVm.data.purchase_payment_apply,
          {
            showSelect: true
          }
        );
      }
      if (
        formVm &&
        formVm.data &&
        formVm.data.concentrate_purchase_receive_material
      ) {
        formVm.data.concentrate_purchase_receive_material.showSelect = true;
        formVm.data.concentrate_purchase_receive_material = Object.assign(
          {},
          formVm.data.concentrate_purchase_receive_material,
          {
            showSelect: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.pro_delivery) {
        formVm.data.pro_delivery.complete_detail_show = true;
        formVm.data.pro_delivery = Object.assign({}, formVm.data.pro_delivery, {
          complete_detail_show: true
        });
      }
      if (formVm && formVm.data && formVm.data.oa_seal_use_apply) {
        formVm.data.oa_seal_use_apply.seal_detail_show = true;
        formVm.data.oa_seal_use_apply = Object.assign(
          {},
          formVm.data.oa_seal_use_apply,
          {
            seal_detail_show: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.pro_confirm) {
        formVm.data.pro_confirm.showRecord = true;
        formVm.data.pro_confirm = Object.assign({}, formVm.data.pro_confirm, {
          showRecord: true
        });
      }
      if (formVm && formVm.data && formVm.data.customer_register) {
        formVm.data.customer_register.customer_name_dialog = true;
        formVm.data.customer_register = Object.assign(
          {},
          formVm.data.customer_register,
          {
            customer_name_dialog: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.concentrate_purchase_transfer) {
        formVm.data.concentrate_purchase_transfer.showSelect = true;
        formVm.data.concentrate_purchase_transfer = Object.assign(
          {},
          formVm.data.concentrate_purchase_transfer,
          {
            showSelect: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.personnel_replace) {
        formVm.data.personnel_replace.project_btn_show = true;
        formVm.data.personnel_replace = Object.assign(
          {},
          formVm.data.personnel_replace,
          {
            project_btn_show: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.cost_contract_payment) {
        if (formVm.data.cost_contract_payment.export_show === true) {
          formVm.data.cost_contract_payment = Object.assign(
            {},
            formVm.data.cost_contract_payment,
            {
              export_show: true
            }
          );
        }
        if (formVm.data.cost_contract_payment.import_show === true) {
          formVm.data.cost_contract_payment = Object.assign(
            {},
            formVm.data.cost_contract_payment,
            {
              import_show: true
            }
          );
        }
        if (formVm.data.cost_contract_payment.son_detail_show === true) {
          formVm.data.cost_contract_payment = Object.assign(
            {},
            formVm.data.cost_contract_payment,
            {
              son_detail_show: true
            }
          );
        }
        if (formVm.data.cost_contract_payment.hand_write_in_show === true) {
          formVm.data.cost_contract_payment = Object.assign(
            {},
            formVm.data.cost_contract_payment,
            {
              hand_write_in_show: true
            }
          );
        }

        if (formVm.data.cost_contract_payment.showDetail == true) {
          formVm.data.cost_contract_payment.showDetail = true;
          formVm.data.cost_contract_payment = Object.assign(
            {},
            formVm.data.cost_contract_payment,
            {
              showDetail: true
            }
          );
        } else if (
          formVm.data.cost_contract_payment.contract_detail_show == true
        ) {
          formVm.data.cost_contract_payment.contract_detail_show = true;
          formVm.data.cost_contract_payment = Object.assign(
            {},
            formVm.data.cost_contract_payment,
            {
              contract_detail_show: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.certificate_operation_record) {
        formVm.data.certificate_operation_record.record_no_detail = true;
        formVm.data.certificate_operation_record = Object.assign(
          {},
          formVm.data.certificate_operation_record,
          {
            record_no_detail: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.bid_bond_transfer) {
        formVm.data.bid_bond_transfer.bidBondDetailShow = true;
        formVm.data.bid_bond_transfer = Object.assign(
          {},
          formVm.data.bid_bond_transfer,
          {
            bidBondDetailShow: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.finance_input_invoice) {
        if (formVm.data.finance_input_invoice.showSelect == true) {
          formVm.data.finance_input_invoice.showSelectBuyer = false;
          formVm.data.finance_input_invoice.id_show = false;
          formVm.data.finance_input_invoice.showSelect = true;
          formVm.data.finance_input_invoice = Object.assign(
            {},
            formVm.data.finance_input_invoice,
            {
              id_show: false,
              showSelect: true,
              showSelectBuyer: false
            }
          );
        } else if (formVm.data.finance_input_invoice.showSelectBuyer == true) {
          formVm.data.finance_input_invoice.showSelectBuyer = true;
          formVm.data.finance_input_invoice.showSelect = false;
          formVm.data.finance_input_invoice.id_show = false;
          formVm.data.finance_input_invoice = Object.assign(
            {},
            formVm.data.finance_input_invoice,
            {
              id_show: false,
              showSelect: false,
              showSelectBuyer: true
            }
          );
        } else if (formVm.data.finance_input_invoice.id_show == true) {
          formVm.data.finance_input_invoice.id_show = true;
          formVm.data.finance_input_invoice.showSelectBuyer = false;
          formVm.data.finance_input_invoice.showSelect = false;
          formVm.data.finance_input_invoice = Object.assign(
            {},
            formVm.data.finance_input_invoice,
            {
              id_show: true,
              showSelect: false,
              showSelectBuyer: false
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.collective_invoice) {
        if (formVm.data.collective_invoice.showSelectFst == true) {
          formVm.data.collective_invoice.showSelectFst = true;
          formVm.data.collective_invoice = Object.assign(
            {},
            formVm.data.collective_invoice,
            {
              showSelectFst: true
            }
          );
        } else if (formVm.data.collective_invoice.showSelectSec == true) {
          formVm.data.collective_invoice.showSelectSec = false;
          formVm.data.collective_invoice = Object.assign(
            {},
            formVm.data.collective_invoice,
            {
              showSelectSec: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.con_pro_output_value) {
        if (formVm.data.con_pro_output_value.showDetail == true) {
          formVm.data.con_pro_output_value.showDetail = true;
          formVm.data.con_pro_output_value = Object.assign(
            {},
            formVm.data.con_pro_output_value,
            {
              showDetail: true
            }
          );
        }
        if (formVm.data.con_pro_output_value.showLogDetail == true) {
          formVm.data.con_pro_output_value.showLogDetail = true;
          formVm.data.con_pro_output_value = Object.assign(
            {},
            formVm.data.con_pro_output_value,
            {
              showLogDetail: true
            }
          );
        }
        if (formVm.data.con_pro_output_value.showtab1 == true) {
          formVm.data.con_pro_output_value.showtab1 = true;
          formVm.data.con_pro_output_value = Object.assign(
            {},
            formVm.data.con_pro_output_value,
            {
              showtab1: true
            }
          );
        }
        if (formVm.data.con_pro_output_value.showtab2 == true) {
          formVm.data.con_pro_output_value.showtab2 = true;
          formVm.data.con_pro_output_value = Object.assign(
            {},
            formVm.data.con_pro_output_value,
            {
              showtab2: true
            }
          );
        }
      }

      if (formVm && formVm.data && formVm.data.finance_project_sharing) {
        if (formVm.data.finance_project_sharing.export == true) {
          formVm.data.finance_project_sharing.export = true;
          formVm.data.finance_project_sharing = Object.assign(
            {},
            formVm.data.finance_project_sharing,
            {
              export: true
            }
          );
        }
        if (formVm.data.finance_project_sharing.import == true) {
          formVm.data.finance_project_sharing.import = true;
          formVm.data.finance_project_sharing = Object.assign(
            {},
            formVm.data.finance_project_sharing,
            {
              import: true
            }
          );
        }
        if (formVm.data.finance_project_sharing.showDetail == true) {
          formVm.data.finance_project_sharing.showDetail = true;
          formVm.data.finance_project_sharing = Object.assign(
            {},
            formVm.data.finance_project_sharing,
            {
              showDetail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.guarantee_deposit_back) {
        if (
          formVm.data.guarantee_deposit_back.guarantee_letter_no_detail == true
        ) {
          formVm.data.guarantee_deposit_back.guarantee_letter_no_detail = true;
          formVm.data.guarantee_deposit_back = Object.assign(
            {},
            formVm.data.guarantee_deposit_back,
            {
              guarantee_letter_no_detail: true
            }
          );
        }
        if (
          formVm.data.guarantee_deposit_back.total_pay_amount_detail == true
        ) {
          formVm.data.guarantee_deposit_back.total_pay_amount_detail = true;
          formVm.data.guarantee_deposit_back = Object.assign(
            {},
            formVm.data.guarantee_deposit_back,
            {
              total_pay_amount_detail: true
            }
          );
        }
        if (formVm.data.guarantee_deposit_back.total_repayment_detail == true) {
          formVm.data.guarantee_deposit_back.total_repayment_detail = true;
          formVm.data.guarantee_deposit_back = Object.assign(
            {},
            formVm.data.guarantee_deposit_back,
            {
              total_repayment_detail: true
            }
          );
        }
      }

      if (formVm && formVm.data && formVm.data.repay_reserve_fund) {
        if (formVm.data.repay_reserve_fund.payment_apply_no_detail == true) {
          formVm.data.repay_reserve_fund.payment_apply_no_detail = true;
          formVm.data.repay_reserve_fund = Object.assign(
            {},
            formVm.data.repay_reserve_fund,
            {
              payment_apply_no_detail: true
            }
          );
        } else if (
          formVm.data.repay_reserve_fund.total_repayment_detail == true
        ) {
          formVm.data.repay_reserve_fund.total_repayment_detail = true;
          formVm.data.repay_reserve_fund = Object.assign(
            {},
            formVm.data.repay_reserve_fund,
            {
              total_repayment_detail: true
            }
          );
        } else if (
          formVm.data.repay_reserve_fund.total_pay_amount_detail == true
        ) {
          formVm.data.repay_reserve_fund.total_pay_amount_detail = true;
          formVm.data.repay_reserve_fund = Object.assign(
            {},
            formVm.data.repay_reserve_fund,
            {
              total_pay_amount_detail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.deposit_back) {
        if (formVm.data.deposit_back.payment_apply_no_detail == true) {
          formVm.data.deposit_back.payment_apply_no_detail = true;
          formVm.data.deposit_back = Object.assign(
            {},
            formVm.data.deposit_back,
            {
              payment_apply_no_detail: true
            }
          );
        } else if (formVm.data.deposit_back.total_pay_amount_detail == true) {
          formVm.data.deposit_back.total_pay_amount_detail = true;
          formVm.data.deposit_back = Object.assign(
            {},
            formVm.data.deposit_back,
            {
              total_pay_amount_detail: true
            }
          );
        } else if (formVm.data.deposit_back.total_repayment_detail == true) {
          formVm.data.deposit_back.total_repayment_detail = true;
          formVm.data.deposit_back = Object.assign(
            {},
            formVm.data.deposit_back,
            {
              total_repayment_detail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.revenue_confirm) {
        if (formVm.data.revenue_confirm.export == true) {
          formVm.data.revenue_confirm.export = true;
          formVm.data.revenue_confirm = Object.assign(
            {},
            formVm.data.revenue_confirm,
            {
              export: true
            }
          );
        }
        if (formVm.data.revenue_confirm.import == true) {
          formVm.data.revenue_confirm.import = true;
          formVm.data.revenue_confirm = Object.assign(
            {},
            formVm.data.revenue_confirm,
            {
              import: true
            }
          );
        }
        if (formVm.data.revenue_confirm.showDetail == true) {
          formVm.data.revenue_confirm.showDetail = true;
          formVm.data.revenue_confirm = Object.assign(
            {},
            formVm.data.revenue_confirm,
            {
              showDetail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.con_material_suppcoller) {
        formVm.data.con_material_suppcoller.cms_supplier_detail = true;
        formVm.data.con_material_suppcoller = Object.assign(
          {},
          formVm.data.con_material_suppcoller,
          {
            cms_supplier_detail: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.tax_payable_apportion) {
        if (formVm.data.tax_payable_apportion.export === true) {
          formVm.data.tax_payable_apportion = Object.assign(
            {},
            formVm.data.tax_payable_apportion,
            {
              export: true
            }
          );
        }
        if (formVm.data.tax_payable_apportion.import === true) {
          formVm.data.tax_payable_apportion = Object.assign(
            {},
            formVm.data.tax_payable_apportion,
            {
              import: true
            }
          );
        }
        if (formVm.data.tax_payable_apportion.detail === true) {
          formVm.data.tax_payable_apportion = Object.assign(
            {},
            formVm.data.tax_payable_apportion,
            {
              detail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.cost_contract) {
        if (formVm.data.cost_contract.export === true) {
          formVm.data.cost_contract = Object.assign(
            {},
            formVm.data.cost_contract,
            {
              export: true
            }
          );
        }
        if (formVm.data.cost_contract.import === true) {
          formVm.data.cost_contract = Object.assign(
            {},
            formVm.data.cost_contract,
            {
              import: true
            }
          );
        }
        if (formVm.data.cost_contract.subTabimport === true) {
          formVm.data.cost_contract = Object.assign(
            {},
            formVm.data.cost_contract,
            {
              subTabimport: true
            }
          );
        }
        if (formVm.data.cost_contract.importDetail === true) {
          formVm.data.cost_contract = Object.assign(
            {},
            formVm.data.cost_contract,
            {
              importDetail: true
            }
          );
        }
        if (formVm.data.cost_contract.insert === true) {
          formVm.data.cost_contract = Object.assign(
            {},
            formVm.data.cost_contract,
            {
              insert: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.concentrate_purchase_plan) {
        if (formVm.data.concentrate_purchase_plan.export === true) {
          formVm.data.concentrate_purchase_plan = Object.assign(
            {},
            formVm.data.concentrate_purchase_plan,
            {
              export: true
            }
          );
        }
        if (formVm.data.concentrate_purchase_plan.import === true) {
          formVm.data.concentrate_purchase_plan = Object.assign(
            {},
            formVm.data.concentrate_purchase_plan,
            {
              import: true
            }
          );
        }
        if (formVm.data.concentrate_purchase_plan.subTabimport === true) {
          formVm.data.concentrate_purchase_plan = Object.assign(
            {},
            formVm.data.concentrate_purchase_plan,
            {
              subTabimport: true
            }
          );
        }
        if (formVm.data.concentrate_purchase_plan.importDetail === true) {
          formVm.data.concentrate_purchase_plan = Object.assign(
            {},
            formVm.data.concentrate_purchase_plan,
            {
              importDetail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.cost_contract_subjoin) {
        if (formVm.data.cost_contract_subjoin.export === true) {
          formVm.data.cost_contract_subjoin = Object.assign(
            {},
            formVm.data.cost_contract_subjoin,
            {
              export: true
            }
          );
        }
        if (formVm.data.cost_contract_subjoin.import === true) {
          formVm.data.cost_contract_subjoin = Object.assign(
            {},
            formVm.data.cost_contract_subjoin,
            {
              import: true
            }
          );
        }
        if (formVm.data.cost_contract_subjoin.subTabimport === true) {
          formVm.data.cost_contract_subjoin = Object.assign(
            {},
            formVm.data.cost_contract_subjoin,
            {
              subTabimport: true
            }
          );
        }
        if (formVm.data.cost_contract_subjoin.importDetail === true) {
          formVm.data.cost_contract_subjoin = Object.assign(
            {},
            formVm.data.cost_contract_subjoin,
            {
              importDetail: true
            }
          );
        }
        if (formVm.data.cost_contract_subjoin.insert === true) {
          formVm.data.cost_contract_subjoin = Object.assign(
            {},
            formVm.data.cost_contract_subjoin,
            {
              insert: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.concentrate_order) {
        if (formVm.data.concentrate_order.export === true) {
          formVm.data.concentrate_order = Object.assign(
            {},
            formVm.data.concentrate_order,
            {
              export: true
            }
          );
        }
        if (formVm.data.concentrate_order.import === true) {
          formVm.data.concentrate_order = Object.assign(
            {},
            formVm.data.concentrate_order,
            {
              import: true
            }
          );
        }
        if (formVm.data.concentrate_order.hand_in === true) {
          formVm.data.concentrate_order = Object.assign(
            {},
            formVm.data.concentrate_order,
            {
              hand_in: true
            }
          );
        }
        if (formVm.data.concentrate_order.from_in === true) {
          formVm.data.concentrate_order = Object.assign(
            {},
            formVm.data.concentrate_order,
            {
              from_in: true
            }
          );
        }
        if (formVm.data.concentrate_order.import_detail === true) {
          formVm.data.concentrate_order = Object.assign(
            {},
            formVm.data.concentrate_order,
            {
              import_detail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.completion_reply) {
        if (formVm.data.completion_reply.pro_task_detail === true) {
          formVm.data.completion_reply = Object.assign(
            {},
            formVm.data.completion_reply,
            {
              pro_task_detail: true
            }
          );
        }
        if (formVm.data.completion_reply.completion_reply_detail === true) {
          formVm.data.completion_reply = Object.assign(
            {},
            formVm.data.completion_reply,
            {
              completion_reply_detail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.construction_pro) {
        if (formVm.data.construction_pro.maketing_pro_no_detail === true) {
          formVm.data.construction_pro = Object.assign(
            {},
            formVm.data.construction_pro,
            {
              maketing_pro_no_detail: true
            }
          );
        } else if (
          formVm.data.construction_pro.bid_confirmation_no_detail === true
        ) {
          formVm.data.construction_pro = Object.assign(
            {},
            formVm.data.construction_pro,
            {
              bid_confirmation_no_detail: true
            }
          );
        } else if (
          formVm.data.construction_pro.bid_disclosure_no_detail === true
        ) {
          formVm.data.construction_pro = Object.assign(
            {},
            formVm.data.construction_pro,
            {
              bid_disclosure_no_detail: true
            }
          );
        } else if (
          formVm.data.construction_pro.bid_document_appraise_detail === true
        ) {
          formVm.data.construction_pro = Object.assign(
            {},
            formVm.data.construction_pro,
            {
              bid_document_appraise_detail: true
            }
          );
        }
      }
      if (formVm && formVm.data && formVm.data.guarantee_letter) {
        formVm.data.guarantee_letter.showDetail = true;
        formVm.data.guarantee_letter = Object.assign(
          {},
          formVm.data.guarantee_letter,
          {
            showDetail: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.bid_bond) {
        formVm.data.bid_bond.showDetail = true;
        formVm.data.bid_bond = Object.assign({}, formVm.data.bid_bond, {
          showDetail: true
        });
      }
      if (formVm && formVm.data && formVm.data.guarantee_letter) {
        formVm.data.guarantee_letter.showDetail = true;
        formVm.data.guarantee_letter = Object.assign(
          {},
          formVm.data.guarantee_letter,
          {
            showDetail: true
          }
        );
      }
      if (formVm && formVm.data && formVm.data.finance_advance_fund) {
        if (formVm.data.finance_advance_fund.showContractDetail === true) {
          formVm.data.finance_advance_fund = Object.assign(
            {},
            formVm.data.finance_advance_fund,
            {
              showContractDetail: true
            }
          );
        } else if (
          formVm.data.finance_advance_fund.showReceiveDetail === true
        ) {
          formVm.data.finance_advance_fund = Object.assign(
            {},
            formVm.data.finance_advance_fund,
            {
              showReceiveDetail: true
            }
          );
        } else if (formVm.data.finance_advance_fund.showReportDetail === true) {
          formVm.data.finance_advance_fund = Object.assign(
            {},
            formVm.data.finance_advance_fund,
            {
              showReportDetail: true
            }
          );
        } else if (
          formVm.data.finance_advance_fund.showBalanceDetail === true
        ) {
          formVm.data.finance_advance_fund = Object.assign(
            {},
            formVm.data.finance_advance_fund,
            {
              showBalanceDetail: true
            }
          );
        }
      }

      if (formVm && formVm.data && formVm.data.finance_external_syndrome) {
        formVm.data.finance_external_syndrome.showDetail = true;
        formVm.data.finance_external_syndrome = Object.assign(
          {},
          formVm.data.finance_external_syndrome,
          {
            showDetail: true
          }
        );
      }

      if (formVm && formVm.data && formVm.data.design_invoice) {
        formVm.data.design_invoice.showDetail = true;
        formVm.data.design_invoice = Object.assign(
          {},
          formVm.data.design_invoice,
          {
            showDetail: true
          }
        );
      }

      if (formVm && formVm.data && formVm.data.construction_worker) {
        if (formVm.data.construction_worker.id_btn === true) {
          formVm.data.construction_worker.id_btn = true;
          formVm.data.construction_worker = Object.assign(
            {},
            formVm.data.construction_worker,
            {
              id_btn: true
            }
          );
        }
      }

      if (formVm && formVm.data && formVm.data.construction_worker) {
        if (formVm.data.construction_worker.bank_btn === true) {
          formVm.data.construction_worker.bank_btn = true;
          formVm.data.construction_worker = Object.assign(
            {},
            formVm.data.construction_worker,
            {
              bank_btn: true
            }
          );
        }
      }

      if (resultValue) {
        this.inputValue = resultValue;
        this.$emit("input", resultValue);
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}

.form-table {
  width: 100%;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.form-table th {
  text-align: left;
  color: #666;
}

.form-table th > span {
  color: #f00;
}

.form-table th, .form-table td {
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}
</style>
